import { gql } from '@apollo/client';
import { eventListingAttributes } from './types/event';
import { eventSeriesAttributes } from './types/event-series';
import { userFollowAttributes } from './types/user-follow';

export const meQuery = gql`
  query MeQuery {
    me {
      id
      username
      email
    }
  }
`;

export const usersQuery = gql`
  query UsersQuery {
    users {
      id
      username
      displayName
      avatar {
        small {
          url
        }
      }
    }
  }
`;

export const userQuery = gql`
  query UserQuery($username: String!) {
    user(username: $username) {
      id
      discoverable
      displayName
      givenName
      familyName
      username
      about
      websiteUrl
      instagramUsername
      pronouns
      avatar {
        med {
          url
        }
        large {
          url
        }
      }
      primaryCity {
        id
        name
        slug
      }
      hostedEvents(limit: 10) {
        ${eventListingAttributes}
      }
      hostedEventsCount
      pastHostedEventsCount
      hostedEventSeries {
        ${eventSeriesAttributes}
        description
        recurringType
        separationCount
        dayOfWeek
        weekOfMonth
        dayOfMonth
        upcomingEventsCount
        upcomingEvents(limit: 1) {
          id
          startAt
          endAt
          timezone
        }
      }
    }
  }
`;

export const userMoreEventsQuery = gql`
  query UserMoreEventsQuery($username: String!, $offset: Int!) {
    user(username: $username) {
      id
      hostedEvents(limit: 10, offset: $offset) {
        ${eventListingAttributes}
      }
    }
  }
`;

export const userPastEventsQuery = gql`
  query UserPastEventsQuery($username: String!, $offset: Int) {
    user(username: $username) {
      id
      pastHostedEvents(limit: 10, offset: $offset) {
        ${eventListingAttributes}
      }
    }
  }
`;

export const followUserMutation = gql`
  mutation FollowUserMutation($id: ID!) {
    followUser(id: $id) {
      ${userFollowAttributes}
    }
  }
`;

export const unfollowUserMutation = gql`
  mutation UnfollowUserMutation($id: ID!) {
    unfollowUser(id: $id) {
      ${userFollowAttributes}
    }
  }
`;

export const updateUserFollowMutation = gql`
  mutation UpdateUserFollowMutation($userId: ID!, $data: UserFollowInput!) {
    updateUserFollow(userId: $userId, data: $data) {
      ${userFollowAttributes}
    }
  }
`;

export const userSearchQuery = gql`
  query UserSearchQuery($query: String!) {
    userSearch(query: $query) {
      id
      username
      displayName
      avatar {
        small {
          url
        }
      }
    }
  }
`;
